import React from 'react'
import {
  Show,
  TextField,
  DateField,
  ArrayField,
  Datagrid,
  BooleanField,
} from 'react-admin';
import { Box } from '@mui/material';
import NestedReferenceField from '../../components/NestedReferenceField';
import SelfLinkField from '../../components/SelfLinkField';

const VetCaseShow = (props) => {
  return (
    <Show {...props} title="Vet Case Details">
      <Box display="flex" flexDirection="column" gap={2} padding={2}>
        <TextField source="id" label="ID" />
        <NestedReferenceField source="horse" labelField="name" resource="horses" label="Horse" />
        <NestedReferenceField source="team" labelField="name" resource="teams" label="Team" />
        <TextField source="case_number" label="Case number" />
        <TextField source="reason" label="Reason" />
        <TextField source="vet_name" label="Vet name" />
        <TextField source="notes" label="Notes" />
        <BooleanField source="auto_add_future_horse_exams" label="Auto add future horse exams" />
        <DateField source="creation_date" label="Created at" showTime />
        <DateField source="update_date" label="Updated at" showTime />

        <ArrayField source="user_in_vet_cases">
          <Datagrid bulkActionButtons={false}>
            <NestedReferenceField source="user" labelField="email" resource="users" label="User" />
          </Datagrid>
        </ArrayField>

        <ArrayField source="reports">
          <Datagrid bulkActionButtons={false}>
            <SelfLinkField source="id" resource="reports" label="Report" />
            <BooleanField source="published" label="Published" />
          </Datagrid>
        </ArrayField>
      </Box>
    </Show>
  );
};

export default VetCaseShow;
